
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/viewOnline",
      function () {
        return require("private-next-pages/viewOnline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/viewOnline"])
      });
    }
  